import { PlayerLevelStatus } from '@app/models/player-level-status';
import { createAction, props } from '@ngrx/store';

export const upsertOne = createAction('[Player Level Status] Upsert Player Level Status', props<{ playerLevelStatus: PlayerLevelStatus }>());
